import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import React from 'react';
import { hideOthers } from 'aria-hidden';
var PREVENT_ARIA_HIDDEN_ATTRIBUTE = 'data-prevent-aria-hidden';

// Hide everything except modalElement, live regions, and
// elements with the PREVENT_ARIA_HIDDEN_ATTRIBUTE
function hideForModal(modalElement) {
  return hideOthers([modalElement].concat(_toConsumableArray(Array.from(document.querySelectorAll("[aria-live]"))), _toConsumableArray(Array.from(document.querySelectorAll("[".concat(PREVENT_ARIA_HIDDEN_ATTRIBUTE, "]"))))));
}

// A helper component that applies the PREVENT_ARIA_HIDDEN_ATTRIBUTE
// to its (only) child component

function PreventModalAriaHidden(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.cloneElement(React.Children.only(children), _defineProperty({}, PREVENT_ARIA_HIDDEN_ATTRIBUTE, true));
}
export { hideForModal, PreventModalAriaHidden };